import { useNumberFormat } from 'hooks/useNumberFormat';
import { ConfirmedOfferLogo } from 'svg/ConfirmedOfferLogo';
import { ConfirmedOfferLogoMobile } from 'svg/ConfirmedOfferLogoMobile';
import { FlexiLoanLogo } from 'svg/FlexiLoanLogo';
import { FlexiLoanMobileLogo } from 'svg/FlexiLoanLogoMobile';
import { DocumentUploadInfo } from '../DocumentUploadInfo/DocumentUploadInfo';
import { TUseOffersTabsValues } from '../helpers/useOffersTabs.hook';
import { TradingHistoryTitle } from '../TradingHistoryTitle/TradingHistoryTitle';
import { getProbabilityPill } from './OffersTabs.helpers';
import styles from './OffersTabs.module.css';
import { OfferTab } from './OfferTab/OfferTab';

type TProps = TUseOffersTabsValues &
  Required<Pick<TUseOffersTabsValues, 'indicativeOffer'>>;

export const OffersTabs = ({
  currentView,
  indicativeOffer,
  instantOffer,
  handleTabChange,
}: TProps) => {
  const { formatCurrency, formatPercentage } = useNumberFormat();

  return (
    <div className={styles.tabs}>
      <h1 className={styles.title}>
        🎉 Good news - the application has passed our initial checks
      </h1>
      <TradingHistoryTitle />
      <div className={styles.tabsSection}>
        <OfferTab
          icon={FlexiLoanLogo}
          mobileIcon={FlexiLoanMobileLogo}
          duration="Up to 60 months"
          amount="Up to £1 million"
          interest="From 1.0%"
          pill={getProbabilityPill(indicativeOffer)}
          isSelectable={Boolean(instantOffer)}
          isSelected={currentView === 'documentUpload'}
          onSelect={() => handleTabChange('documentUpload')}
        />
        {instantOffer && (
          <OfferTab
            icon={ConfirmedOfferLogo}
            mobileIcon={ConfirmedOfferLogoMobile}
            duration="Up to 12 months"
            amount={formatCurrency(instantOffer.max_amount)}
            interest={formatPercentage(instantOffer.interest_rate)}
            pill={{ variant: 'london', label: 'Ready to drawdown' }}
            isSelectable
            isSelected={currentView === 'instantOffer'}
            onSelect={() => handleTabChange('instantOffer')}
          />
        )}
      </div>
      <div className={styles.subTitle}>
        {currentView === 'documentUpload' ? (
          <DocumentUploadInfo />
        ) : (
          <span>You're all set! Confirm here to proceed with this offer.</span>
        )}
      </div>
    </div>
  );
};
